export const realestateConstruction = {
    problem: {
        label: 'Pouvez-vous décrire brièvement la nature du problème?',
    },
    damageValue: {
        label: 'Quelle est la valeur des dommages (montant que vous réclamez ou que l’on vous réclame)?',
    },
    formalNotice: {
        label: 'Avez-vous reçu ou transmis un avis / mise en demeure ou procédure dans ce dossier?',
        fieldType: 'yesNoDontKnow',
    },
    expert: {
        label: 'Avez-vous mandaté un expert ou autre entrepreneur pour le dossier (évaluateur, entrepreneur, ingénieur, inspecteur etc.)?',
        fieldType: 'yesNo',
        autoCheckCondition: (val) => val === 'yes',
    },
    amicable: {
        label: 'Êtes-vous confiant que votre dossier puisse se régler à l’amiable?',
        fieldType: 'yesNoDontKnow',
    },
}

export const realestateCondo = {
    condoType: {
        label: 'Est-ce qu’il s’agit d’une copropriété divise ou indivise?',
        fieldType: 'buttonRow',
        options: [
            {
                label: 'Divise',
                value: 'divise',
            },
            {
                label: 'Indivise',
                value: 'indivise',
            },
        ],
    },
    ownersNumber: {
        label: 'Combien de copropriétaire y-a-t-il dans l’immeuble?',
    },
    syndicate: {
        label: 'Est-ce que vous faites partie du syndicat de copropriété/conseil d’administration de la copropriété?',
        fieldType: 'yesNo',
    },
    unitValue: {
        label: 'Quelle est la valeur de votre unité?',
        fieldType: 'number',
    },
    job: {
        label: 'Quel est votre occupation ou emploi?',
    },
    formalNotice: {
        label: 'Avez-vous reçu ou transmis un avis / mise en demeure ou procédure dans ce dossier?',
        fieldType: 'yesNoDontKnow',
    },
}

export const realestateVice = {
    label1: {
        fieldType: 'label',
        label: 'Votre vice-caché',
    },
    buySell: {
        label: 'Acheteur ou vendeur?',
        fieldType: 'buttonRow',
        options: [
            {
                value: 'buyer',
                label: 'Acheteur',
            },
            {
                value: 'seller',
                label: 'Vendeur',
            },
        ],
        preFormOnly: true,
        autoCheck: true,
    },
    propertyType: {
        label: 'Le bien visé correspond à quelle catégorie',
        fieldType: 'select',
        options: [
            {
                name: 'realestate',
                label: 'Immobilier (terrain, bâtisse, chalet, maison mobile)',
            },
            {
                name: 'mobile',
                label: 'Mobilier (bâteau, roulotte, VR, voiture, moto, équipements, meubles divers, etc)',
            },
            {
                name: 'other',
                label: 'Autre/Je ne sais pas',
            },
        ],
        preFormOnly: true,
        autoCheckCondition: (val) => val === 'realesate',
    },
    otherPropertyType: {
        label: 'Préciser le bien',
        dependsOn: {
            fieldName: 'propertyType',
            toBe: ['mobile', 'other'],
        },
        preFormOnly: true,
    },
    buyerWants: {
        label: 'Vous souhaitez',
        fieldType: 'select',
        options: [
            {
                name: 'cancel',
                label: 'L’annulation de la vente',
            },
            {
                name: 'reduce',
                label: 'La réduction du prix de vente (dédommagement pour les travaux de réparation)',
            },
            {
                name: 'other',
                label: 'Autre / Je ne sais pas',
            },
        ],
        dependsOn: {
            fieldName: 'buySell',
            toBe: 'buyer',
        },
        preFormOnly: true,
    },
    sellerWants: {
        label: 'L’acheteur recherche',
        fieldType: 'select',
        options: [
            {
                name: 'cancel',
                label: 'L’annulation de la vente',
            },
            {
                name: 'reduce',
                label: 'La réduction du prix de vente (dédommagement pour les travaux de réparation)',
            },
            {
                name: 'other',
                label: 'Autre / Je ne sais pas',
            },
        ],
        dependsOn: {
            fieldName: 'buySell',
            toBe: 'seller',
        },
        preFormOnly: true,
    },
    otherWants: {
        label: 'Précisez ce que vous recherchez',
        dependsOnOne: [
            {
                fieldName: 'sellerWants',
                toBe: 'other',
            },
            {
                fieldName: 'buyerWants',
                toBe: 'other',
            },
        ],
        preFormOnly: true,
    },
    letter: {
        label: 'Avez-vous reçu ou transmis un avis de connaissance du vice, mise en demeure ou procédure dans ce dossier?',
        fieldType: 'yesNoDontKnow',
        postFormOnly: true,
        autoCheck: true,
    },
    value: {
        label: 'Quelle est la valeur du vice (montant que vous réclamez ou que l’on vous réclame)?',
        postFormOnly: true,
    },
    expert: {
        label: 'Avez-vous mandaté un expert pour le dossier (évaluateur, entrepreneur, ingénieur, inspecteur etc)',
        fieldType: 'yesNo',
        postFormOnly: true,
        autoCheck: true,
    },
    otherExpert: {
        label: `Précisez le type d'expert mandaté`,
        dependsOn: {
            fieldName: 'expert',
            toBe: 'yes',
        },
        postFormOnly: true,
    },
    amicable: {
        label: 'Êtes-vous confiant que votre dossier puisse se régler à l’amiable?',
        fieldType: 'yesNoDontKnow',
        postFormOnly: true,
    },
    otherDetails: {
        label: 'Souhaitez-vous nous fournir d’autres détails que vous jugez importants?',
        postFormOnly: true,
    },
}

export const realestateTransaction = {
    label1: {
        label: 'Donnez-nous des détails sur votre transaction',
        preFormOnly: true,
        fieldType: 'label',
    },
    transactionType: {
        label: 'Quel type de transaction immobilière recherchez-vous?',
        fieldType: 'select',
        options: [
            {
                name: 'buyer',
                label: 'Achat',
            },
            {
                name: 'seller',
                label: 'Vente',
            },
            {
                name: 'ownerRefinancing',
                label: 'Refinancement du propriétaire',
            },
            {
                name: 'mortageFinancing',
                label: "Quelqu'un qui cherche un financement hypothécaire",
            },
            {
                name: 'other',
                label: 'Autre',
            },
        ],
        preFormOnly: true,
        autoCheckCondition: (val) => val === 'buyer' || val === 'seller',
    },
    otherTransactionType: {
        label: 'Préciser',
        dependsOn: {
            fieldName: 'transactionType',
            toBe: 'other',
        },
        preFormOnly: true,
    },
    numProperties: {
        label: 'Combien de propriétés sont impliquées dans cette transaction?',
        fieldType: 'select',
        options: [
            {
                name: '1',
                label: '1',
            },
            {
                name: '2',
                label: '2',
            },
            {
                name: '3',
                label: '3',
            },
            {
                name: '4+',
                label: '4 ou plus',
            },
        ],
        preFormOnly: true,
    },
    propertyType: {
        label: 'Quel(s) est/sont le(s) type(s) de propriété(s)?',
        fieldType: 'checkBoxes',
        options: [
            {
                name: 'detached-freehold',
                label: 'Détaché ou en pleine propriété',
            },
            {
                name: 'condo',
                label: 'Condo',
            },
            {
                name: 'semi-detached',
                label: 'Semi-détaché',
            },
            {
                name: 'mixed',
                label: 'Mixte',
            },
        ],
        preFormOnly: true,
    },
    specifyMixed: {
        label: 'Préciser, mixte',
        dependsOn: {
            fieldName: 'propertyType',
            toBe: 'mixed',
        },
        preFormOnly: true,
    },

    propertyValue: {
        label: 'Quelle est la valeur de la propriété ou des propriétés',
        preFormOnly: true,
    },
    mortgageCommitment: {
        label: "Avez-vous un engagement hypothécaire d'un prêteur financier?",
        fieldType: 'yesNo',
        preFormOnly: true,
    },
    mortgageAmount: {
        label: "Quel est le montant de l'hypothèque?",
        dependsOn: {
            fieldName: 'mortgageCommitment',
            toBe: 'yes',
        },
        preFormOnly: true,
    },
    agreement: {
        label: "S'il s'agit d'un achat ou d'une vente, avez-vous signé une convention d'achat/vente?",
        fieldType: 'yesNo',
        preFormOnly: true,
    },
    closingDate: {
        label: 'Quelle est la date de clôture?',
        fieldType: 'date',
        preFormOnly: true,
    },
    otherDetails: {
        label: "Avez-vous d'autres détails que vous aimeriez partager?",
        preFormOnly: true,
    },
}
